// Configuration for file types used in franchisee document uploads
// Data is now stored in Firestore and queried dynamically
// All file types require expiry dates as per business requirements

import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

// These types are managed via the dedicated Compliance section on the Edit Franchisee page,
// not through general file attachments.
const COMPLIANCE_ONLY_TYPES = ["police-certificate", "certificate-of-currency"];

const DEFAULT_FILE_TYPES = [
  { value: "other", label: "Other" },
];

/**
 * Filter out compliance-specific file types that have dedicated upload workflows.
 * @param {Array} types
 * @returns {Array}
 */
export const filterAttachmentFileTypes = (types) =>
  types.filter((t) => !COMPLIANCE_ONLY_TYPES.includes(t.value));

/**
 * Fetch file types from Firestore
 * @returns {Promise<Array>} Array of file type objects
 */
export const fetchFileTypes = async () => {
  try {
     const fileTypesRef = doc(db, "config", "app-config");
    const docSnap = await getDoc(fileTypesRef);

    if (!docSnap.exists()) {
      console.warn("No such document: config/app-config");
      return DEFAULT_FILE_TYPES;
    }

    let fileTypes = docSnap.data().fileTypes || [];

    if (fileTypes.length === 0) {
      return DEFAULT_FILE_TYPES;
    }

     // Modified sort to put "Other" type last
    fileTypes = fileTypes.sort((a, b) => {
      if (a.value === "other") return 1;  // Move "other" to end
      if (b.value === "other") return -1; // Move "Other" to end
      return a.label.localeCompare(b.label); // Regular alphabetical sort for rest
    });

    return fileTypes;
  } catch (error) {
    console.error("Error fetching file types from Firestore:", error);
    return DEFAULT_FILE_TYPES;
  }
};

/**
 * Check if a file type requires custom input
 * @param {string} value - The file type value
 * @returns {boolean} Always returns false as isCustom field is removed
 */
export const isCustomFileType = (value) => {
  // Since isCustom field is removed, determine based on value
  return value === "other";
};
